import { api, useCurrentUser } from '@cma/app'
import {
  CreateBrandingMutation,
  CreateBrandingMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useCreateBranding() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    CreateBrandingMutation,
    Error,
    CreateBrandingMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation CreateBranding($input: BrandingInput!) {
          createBranding(input: $input) {
            branding {
              brandableId
              brandableType
              name
              locked
              logoUrl
              secondaryLogoUrl
              primaryColor
              secondaryColor
              primaryFont
              secondaryFont
              published
              createdBy
            }
          }
        }
      `
      return api<CreateBrandingMutation, CreateBrandingMutationVariables>({
        query,
        variables
      })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformClient',
          { id: currentUser?.account?.id || '' }
        ])
      }
    }
  )
}
